export default __webpack_public_path__ + "static/media/HEADERS-DD-Xpress.fe734d90.png";